import { properties } from '@/utils/properties';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdmPerfil } from './adm-perfil.service';
import { AdmPantalla } from './adm-modulo.service';

export interface AdmPerfilPantalla {
  id_perfil_pantalla?: number;
  id_perfil: number;
  id_pantalla: number;
  activo?: number;
  usuario_asignacion?: string;
  fecha_asignacion?: string;
  perfil?: AdmPerfil;
  pantalla?: AdmPantalla;
}

export interface PantallaAsignacion {
  id_pantalla: number;
}

export interface AsignacionMultiple {
  id_perfil: number;
  pantallas: PantallaAsignacion[];
  usuario_asignacion?: string;
}

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
  meta?: any;
}

export interface MenuItem {
  id: number;
  nombre: string;
  ruta: string | null;
  icono: string;
  orden: number;
  es_modulo: boolean;
  asignada: boolean;
  children: MenuItem[];
}

@Injectable({
  providedIn: 'root'
})
export class AdmPerfilPantallaService {

  private baseUrl = properties.URL_ADMIN + 'adm-perfil-pantalla';

  constructor(private http: HttpClient) { }

  /**
   * Obtener todas las asignaciones perfil-pantalla
   */
  getAll(): Observable<AdmPerfilPantalla[]> {
    return this.http.get<AdmPerfilPantalla[]>(this.baseUrl, properties.httpOptions);
  }

  /**
   * Obtener pantallas de un perfil específico
   */
  getByPerfil(idPerfil: number): Observable<ApiResponse<AdmPerfilPantalla[]>> {
    return this.http.get<ApiResponse<AdmPerfilPantalla[]>>(`${this.baseUrl}/perfil/${idPerfil}`, properties.httpOptions);
  }

  /**
   * Obtener una asignación específica
   */
  getById(id: number): Observable<ApiResponse<AdmPerfilPantalla>> {
    return this.http.get<ApiResponse<AdmPerfilPantalla>>(`${this.baseUrl}/${id}`, properties.httpOptions);
  }

  /**
   * Asignar pantalla a perfil
   */
  create(asignacion: AdmPerfilPantalla): Observable<ApiResponse<AdmPerfilPantalla>> {
    return this.http.post<ApiResponse<AdmPerfilPantalla>>(this.baseUrl, asignacion, properties.httpOptions);
  }

  /**
   * Asignar múltiples pantallas a un perfil
   */
  createMultiple(asignacion: AsignacionMultiple): Observable<ApiResponse<AdmPerfilPantalla[]>> {
    return this.http.post<ApiResponse<AdmPerfilPantalla[]>>(`${this.baseUrl}/multiple`, asignacion, properties.httpOptions);
  }

  /**
   * Actualizar asignación
   */
  update(id: number, asignacion: AdmPerfilPantalla): Observable<ApiResponse<AdmPerfilPantalla>> {
    return this.http.put<ApiResponse<AdmPerfilPantalla>>(`${this.baseUrl}/${id}`, asignacion, properties.httpOptions);
  }

  /**
   * Eliminar asignación
   */
  delete(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`, properties.httpOptions);
  }

  /**
   * Eliminar múltiples pantallas de un perfil
   */
  deleteMultiple(idPerfil: number, pantallas: number[]): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.baseUrl}/delete-multiple`, {
      id_perfil: idPerfil,
      pantallas: pantallas
    }, properties.httpOptions);
  }

  /**
   * Obtener pantallas del usuario autenticado (basado en sus perfiles)
   * Retorna estructura jerárquica para construir menú de navegación
   */
  getPantallasUsuarioActual(): Observable<ApiResponse<MenuItem[]>> {
    return this.http.get<ApiResponse<MenuItem[]>>(`${this.baseUrl}/usuario/current`, properties.httpOptions);
  }
}
